
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/additional-terms",
      function () {
        return require("private-next-pages/legal/additional-terms/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/additional-terms"])
      });
    }
  